function autoSubmit() {
  $('#filter_form .filter-input').change(function() {
    $("#filter_submit").click();
  })
}

document.addEventListener('turbolinks:load', autoSubmit);
